/** Investors page copy. EN mirrors SV until proper translations are added. */
export const investorsTranslationsSv = {
    yearlyOverview: {
        title: 'Sammanställning',
        guarantor: 'Garantiåtagare',
        subscription: 'Teckningsåtagare',
        participant: 'Deltagare',
        total: 'Totalt',
    },
    history: {
        title: 'Historik',
        noResults: 'Inga historiska emissioner hittades',
        cancelledSuffix: ' (avbruten)',
        viewIssueDetails: 'Visa detaljer om emissionen',
        viewWarrantDetails: 'Visa detaljer om teckningsoptionen',
        amountDisclaimer:
            'Fullständig information angående belopp per deltagare har ej kommunicerats av bolaget.',
        columns: {
            date: 'Datum',
            instrument: 'Emission/TO',
            sector: 'Bransch',
            financialAdvisor: 'Fin. rådgivare',
            commitment: 'Åtagande',
            amount: 'Belopp',
        },
    },
    commitmentTypes: {
        seller: 'Säljare',
        subscriptionWithoutRights: 'TÅ utan rätter',
        subscription: 'Teckningsåtagande',
        lender: 'Långivare',
        participant: 'Deltagare',
        putOption: 'Säljoption',
        guarantee: 'Garantiåtagande',
    },
}
